export const SELECTED_BUSINESS_UNIT = 'SELECTED_BUSINESS_UNIT';